module.exports = __webpack_public_path__ + "static/img/putcontent_6.434bb6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/putcontent_6.png
// module id = 6eCR
// module chunks = 1